import { FilterState } from './types';

export const DEFAULT_FILTERS: FilterState = {
  jobType: [],
  jobStatus: [],
  program: [],
  sector: [],
  domain: [],
  reports: [],
  gdoStatus: [],
  gdo: [],
  stageName: [],
  scheduleCategory: [],
  scheduledForNext: [],
  sourceCategory: [],
  sourceSubcategory: [],
  sourceType: [],
  businessApplication: [],
  businessStream: [],
  market: [],
  miscellaneousSectors: [],
  additionalFilters: [],
  dashboardName: [],
  frequency: [],
};

export const primaryFields = ['program', 'sector', 'miscellaneousSectors', 'market', 'jobType', 'businessUnit', 'appName', 'dashboardName', 'frequency', 'gdo', 'businessStream', 'domain', 'businessApplication'];


export const ADDITIONAL_FILTERS = [
  { id: 'all', label: 'All', level: 1 },
  { id: 'scheduleCategory', label: 'Scheduled Category', level: 1 },
  { id: 'scheduledForNext', label: 'Scheduled For', level: 1 },
  { id: 'sourceCategory', label: 'Source Environment', level: 1 }, // Renamed
  { id: 'sourceType', label: 'Source', level: 1 },
  { id: 'sourceSubcategory', label: 'Source Sub Category', level: 2, parent: 'sourceType' },
  { id: 'orchestratorScheduler', label: 'Orchestrator/Scheduler', level: 2, parent: 'sourceType' },
  { id: 'dataAssetName', label: 'Data Asset Name', level: 1 },
  { id: 'department', label: 'Department', level: 1 },
  { id: 'capability', label: 'Capability', level: 1 },
  { id: 'technology', label: 'Technology', level: 1 },
  { id: 'subscriptionName', label: 'Subscription Name', level: 1 },
  { id: 'resourceGroup', label: 'Resource Group', level: 1 },
  { id: 'resourceName', label: 'Resource Name', level: 1 },
  { id: 'sustainOwner', label: 'Sustain Owner', level: 1 },
  { id: 'sustainProdDate', label: 'Sustain PROD Date', level: 1 },
];

export const FILTER_COLORS = {
  panelBg: '#FFFFFF',
  overlayShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
  borderIndent: '#9E9E9E',
  scrollbar: '#F0F0F0',
  accent: '#1976D2',
  placeholder: '#D0D0D0',
  label: '#333333',
  title: '#00366E',
  primaryDark: '#003771',
  inputBg: '#EFF6FF',
  disabledInputBg: '#E7ECF3',
  layersInputBg: '#F8FBFF',
  white: '#FFFFFF',
  shadow: '4px 20px 44px 0px rgba(0, 0, 0, 0.15)',
};

export const STATUS_FILTER_LABELS = {
  SHORT_RUN: 'SHORT RUN',
  SUCCESSFUL: 'Successful',
  FAILED: 'Failed'
}


  
